// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"754625d0","455":"9e0538c4","644":"9fbd69c3"}[chunkId] + ".chunk.js";
};